// Tiny WebAudio synth ported verbatim from the prototype. The ticket-slice sound is a
// paper-shredding effect (bandpass noise burst ~2.6–4.2kHz ripping down to 600Hz over
// ~170ms), NOT a tone — see CLAUDE.md §6.
import { G } from '../game/state';

// Resume/create the AudioContext on first user gesture (autoplay policy).
export function resumeAudio(): void {
  if (!G.AC) G.AC = new (window.AudioContext || (window as any).webkitAudioContext)();
  if (G.AC.state === 'suspended') G.AC.resume();
}

export function tone(f: number, d: number, type: OscillatorType = 'sine', g = 0.15, slide = 0): void {
  const AC = G.AC;
  if (!AC) return;
  const o = AC.createOscillator();
  const v = AC.createGain();
  o.type = type;
  o.frequency.value = f;
  if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(40, f + slide), AC.currentTime + d);
  v.gain.setValueAtTime(g, AC.currentTime);
  v.gain.exponentialRampToValueAtTime(0.0001, AC.currentTime + d);
  o.connect(v).connect(AC.destination);
  o.start();
  o.stop(AC.currentTime + d);
}

function getNoise(): AudioBuffer | null {
  const AC = G.AC;
  if (!AC) return null;
  if (!G.noiseBuf) {
    const n = (AC.sampleRate * 0.3) | 0;
    G.noiseBuf = AC.createBuffer(1, n, AC.sampleRate);
    const d = G.noiseBuf.getChannelData(0);
    for (let i = 0; i < n; i++) d[i] = Math.random() * 2 - 1;
  }
  return G.noiseBuf;
}

export const sfx = {
  slice(): void {
    const AC = G.AC;
    if (!AC) return; // paper shredding: filtered noise burst with a downward rip
    const src = AC.createBufferSource();
    src.buffer = getNoise();
    const bp = AC.createBiquadFilter();
    bp.type = 'bandpass';
    bp.Q.value = 0.9;
    bp.frequency.setValueAtTime(2600 + Math.random() * 1600, AC.currentTime);
    bp.frequency.exponentialRampToValueAtTime(600, AC.currentTime + 0.17);
    const g = AC.createGain();
    g.gain.setValueAtTime(0.3, AC.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, AC.currentTime + 0.17);
    src.connect(bp);
    bp.connect(g);
    g.connect(AC.destination);
    src.start(AC.currentTime, Math.random() * 0.1);
    src.stop(AC.currentTime + 0.2);
  },
  combo(): void {
    tone(523, 0.09, 'square', 0.12);
    setTimeout(() => tone(659, 0.09, 'square', 0.12), 70);
    setTimeout(() => tone(784, 0.14, 'square', 0.14), 140);
  },
  crit(): void {
    tone(1318, 0.12, 'sine', 0.2);
  },
  boom(): void {
    tone(90, 0.5, 'sawtooth', 0.3, -60);
  },
  miss(): void {
    tone(220, 0.25, 'sine', 0.15, -120);
  },
  chute(): void {
    tone(392, 0.1, 'sine', 0.15);
    setTimeout(() => tone(523, 0.1, 'sine', 0.15), 90);
    setTimeout(() => tone(659, 0.2, 'sine', 0.18), 180);
  },
  mash(): void {
    tone(900 + Math.random() * 500, 0.05, 'triangle', 0.1);
  },
};

export function buzz(ms: number | number[]): void {
  if (navigator.vibrate) navigator.vibrate(ms);
}
